import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  updateOrganization as updateOrganizationAction,
  requestManualOrganizationBackup as requestManualOrganizationBackupAction,
} from 'data/organizations/actions'
import { goToOrganizationUpgrade as goToOrganizationUpgradeAction } from 'data/ui/actions'

import {
  isCurrentUserTheOwner,
  canCurrentUserManageOrganization,
  getUser,
  getOrganizationOwner,
} from 'data/users/selectors'
import { getOrganization, isFree } from 'data/organizations/selectors'

import Layout from './Layout'
import useOrganizationField from '../hooks/useOrganizationField'

export default function SettingsOrganizationInformationsJoin() {
  // Data
  const organizationIsFree = useSelector(isFree)
  const canManage = useSelector(canCurrentUserManageOrganization)
  const isOwner = useSelector(isCurrentUserTheOwner)

  const organizationRequestedManualBackupAt = useOrganizationField(
    'requestedManualBackupAt'
  )

  const organizationRequestedManualBackupByName = useSelector(state => {
    const { requestedManualBackupBy } = getOrganization(state)
    if (!requestedManualBackupBy) {
      return null
    }
    const requester = getUser(state, requestedManualBackupBy)
    if (!requester) {
      return 'Someone'
    }
    return requester.displayName
  })

  const organizationOwnerEmail = useSelector(state => {
    const owner = getOrganizationOwner(state)
    if (!owner) {
      return ''
    }
    return owner.email
  })

  const organizationAutomatedBackupSchedule = useOrganizationField(
    'automatedBackupSchedule'
  )

  // Actions
  const dispatch = useDispatch()
  const updateOrganization = React.useCallback(
    params => dispatch(updateOrganizationAction(params)),
    [dispatch]
  )
  const requestManualOrganizationBackup = React.useCallback(
    () => dispatch(requestManualOrganizationBackupAction()),
    [dispatch]
  )
  const goToOrganizationUpgrade = React.useCallback(
    ({ incentiveId }) => {
      dispatch(goToOrganizationUpgradeAction({ incentiveId }))
    },
    [dispatch]
  )

  return (
    <Layout
      organizationIsFree={organizationIsFree}
      organizationOwnerEmail={organizationOwnerEmail}
      organizationRequestedManualBackupByName={
        organizationRequestedManualBackupByName
      }
      organizationRequestedManualBackupAt={organizationRequestedManualBackupAt}
      organizationAutomatedBackupSchedule={organizationAutomatedBackupSchedule}
      canManage={canManage}
      isOwner={isOwner}
      updateOrganization={updateOrganization}
      requestManualOrganizationBackup={requestManualOrganizationBackup}
      goToOrganizationUpgrade={goToOrganizationUpgrade}
    />
  )
}
